import { httpClient } from '@/services/http/httpClient';
import type {
  KnowledgeBaseDocument,
  UploadFileResponse,
  AddUrlResponse,
  CheckUrlResponse,
  KnowledgeBaseDeleteResult,
  AddKnowledgeBaseUrlRequest,
  AddKnowledgeBaseTextRequest,
  AddTextResponse,
  UploadProgressCallback,
} from '@/types';

export const knowledgeBaseApi = {
  /** GET /api/knowledge-base — list all knowledge base documents */
  async list() {
    return httpClient.get<KnowledgeBaseDocument[]>('/knowledge-base');
  },

  /** POST /api/knowledge-base/files — upload a file (multipart) */
  async uploadFile(file: File, onProgress?: UploadProgressCallback) {
    return httpClient.uploadFile<UploadFileResponse>('/knowledge-base/files', file, onProgress);
  },

  /** POST /api/knowledge-base/urls/check — validate a URL before adding */
  async checkUrl(data: AddKnowledgeBaseUrlRequest) {
    return httpClient.post<CheckUrlResponse>('/knowledge-base/urls/check', data);
  },

  /** POST /api/knowledge-base/urls — add a URL reference */
  async addUrl(data: AddKnowledgeBaseUrlRequest) {
    return httpClient.post<AddUrlResponse>('/knowledge-base/urls', data);
  },

  /** POST /api/knowledge-base/text — add a text snippet */
  async addText(data: AddKnowledgeBaseTextRequest) {
    return httpClient.post<AddTextResponse>('/knowledge-base/text', data);
  },

  /** DELETE /api/knowledge-base/:id — remove a document */
  async remove(id: string) {
    return httpClient.delete<KnowledgeBaseDeleteResult>(`/knowledge-base/${id}`);
  },
};
